export const clientTabs = [
    "project",
    "site",
    "articleDetail",
    "articleFile",
    "contact",
    "articleComment"
];

export const siteTabs = [
    "project",
    "articleDetail",
    "articleFile",
    "contact",
    "articleComment"
];

export const projectTabs = [
    "proposal",
    "staffMember",
    "projectTask",
    "articleDetail",
    "articleFile",
    "articleComment",
    "survey",
    "projectJobTitle"
];
